<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .container {
    display: flex;
    height: 179px;
    align-items: center;
    gap: 12px;
    align-self: stretch;
  }
</style>

<script>
  import Feature from "./FeatureComponents/Feature.svelte";
  import Heading from "./FeatureComponents/Heading.svelte";
  import KeyFeature from "./FeatureComponents/KeyFeature.svelte";
</script>

{#snippet noteTaker()}
  <Heading
    src="/assets/img/modules/notetaker.png"
    title="Notetaker"
    subtitle="Focus on the candidate, not the keyboard."
  />
  <KeyFeature text="Automated call summaries" />
  <KeyFeature text="Seamless CRM/ATS syncing" />
  <KeyFeature text="Action-oriented insights" />
{/snippet}

{#snippet inboxAgent()}
  <Heading
    src="/assets/img/modules/inboxAgent.png"
    title="Inbox Agent"
    subtitle="Turn your inbox into a recruiting powerhouse."
  />
  <KeyFeature text="AI-draft replies" />
  <KeyFeature text="Automated follow-up sequences" />
  <KeyFeature text="Smart email coaching" />
{/snippet}

<div class="container">
  <Feature snippet={noteTaker} />
  <Feature snippet={inboxAgent} />
</div>
